import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "src/app/shared/http.service";
import { APIEndpoints } from "src/config/apiEndpoint.config";
import { ExportFieldDto } from "../models/ExportFieldDto";

@Injectable()
export class ExportFieldService {
  constructor(private readonly httpService: HttpService) {}

  getExportFields(): Observable<ExportFieldDto[]> {
    return this.httpService.get(APIEndpoints.getExportFields);
  }

  changeExportField(data: ExportFieldDto) {
    return this.httpService.post(APIEndpoints.changeExportField, data, false);
  }
}
